import ApiClient from '../ApiClient';

const EmailService = {
 
    async sendGmail(accessToken, to, subject, body) {
    if (!accessToken) throw new Error('Missing Gmail access token');
    const payload = { accessToken, to, subject, body };
    const resp = await ApiClient.post('/Email/send_gmail', payload);
    return resp; 
  },

  async getGoogleUserInfo(accessToken) {
    if (!accessToken) throw new Error('Missing Google access token');
    const url = 'https://www.googleapis.com/oauth2/v3/userinfo';
    const resp = await ApiClient.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return resp;
  },

  getStoredGmailToken() {
  const storedAuth = JSON.parse(localStorage.getItem("email_auth"));
  return storedAuth?.emailtype === "gmail" ? storedAuth.access_token : null;
},

 clearStoredEmailAuth() {
    try {
      localStorage.removeItem('email_auth');
    } catch {}
  },
};

export default EmailService;
